module.exports = __webpack_public_path__ + "img/woven.46fafdcf.svg";